import { render } from "./TextLabelRow.vue?vue&type=template&id=84b8dda2"
import script from "./TextLabelRow.vue?vue&type=script&lang=js"
export * from "./TextLabelRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__